import { Fragment } from "react";
import { motion } from "framer-motion";
import { useSpaceStore } from "../../stores";
import { ExploreIcon, MissionsIcon, ShipyardIcon } from "./TabIcon";
import "./CockpitNav.css";

const TABS = [
	{ id: "explore", label: "EXPLORE", Icon: ExploreIcon },
	{ id: "shipyard", label: "SHIPYARD", Icon: ShipyardIcon },
	{ id: "missions", label: "MISSIONS", Icon: MissionsIcon },
] as const;

/** Decorative L-shaped targeting bracket */
function CornerBracket({ side }: { side: "left" | "right" }) {
	const flip = side === "right";
	return (
		<svg
			className={`cockpit-nav__bracket cockpit-nav__bracket--${side}`}
			width="14"
			height="28"
			viewBox="0 0 14 28"
			fill="none"
			style={flip ? { transform: "scaleX(-1)" } : undefined}
		>
			<path
				d="M13 28V6L7 0H0"
				stroke="rgba(45, 212, 168, 0.3)"
				strokeWidth="1"
			/>
			<circle cx="13" cy="28" r="1.5" fill="rgba(45, 212, 168, 0.2)" />
		</svg>
	);
}

export function CockpitNav() {
	const activeTab = useSpaceStore((s) => s.activeTab);
	const setActiveTab = useSpaceStore((s) => s.setActiveTab);

	return (
		<div className="cockpit-nav-wrapper">
			<CornerBracket side="left" />

			<nav className="cockpit-nav">
				{TABS.map((tab, i) => {
					const isActive = activeTab === tab.id;
					return (
						<Fragment key={tab.id}>
							{i > 0 && <div className="cockpit-nav__divider" />}
							<motion.button
								className={`cockpit-nav__tab${isActive ? " cockpit-nav__tab--active" : ""}`}
								onClick={() => setActiveTab(tab.id)}
								whileTap={{ scale: 0.95 }}
								transition={{ duration: 0.1 }}
							>
								<tab.Icon className="cockpit-nav__icon" />
								<span className="cockpit-nav__label">{tab.label}</span>
								{isActive && (
									<motion.div
										className="cockpit-nav__indicator"
										layoutId="cockpit-active-indicator"
										transition={{
											type: "spring",
											stiffness: 400,
											damping: 30,
										}}
									/>
								)}
							</motion.button>
						</Fragment>
					);
				})}
			</nav>

			<CornerBracket side="right" />
		</div>
	);
}
